// extracted by mini-css-extract-plugin
export default {"link":"ChatGPTUsers_link__3aoqR"};